<template>
  <div class="app-feedback">
    <div v-if="navigation.visible" class="navigation-progress" role="progressbar" :aria-label="english ? 'Loading page' : '页面加载中'">
      <div class="navigation-progress__bar" :style="{ transform: `scaleX(${navigation.progress / 100})` }"></div>
    </div>
    <aside v-if="updates.available" class="app-update" role="status" aria-live="polite">
      <header class="app-update__header">
        <strong class="app-update__title">{{ english ? 'A new version is available' : '发现新版本' }}</strong>
        <button
          type="button"
          class="app-update__close"
          :aria-label="english ? 'Close' : '关闭'"
          :disabled="updates.applying"
          @click="postpone"
        >
          <i class="el-icon-close"></i>
        </button>
      </header>
      <p class="app-update__desc">
        {{ english ? 'Please save your current work first, then refresh to get the latest features.' : '请先保存当前操作，再刷新以获取最新功能。' }}
      </p>
      <p v-if="updates.error" class="app-update__error">
        {{ english ? 'Update failed. Check your connection and try again.' : '更新失败，请检查网络后重试。' }}
      </p>
      <div class="app-update__actions">
        <el-button size="small" :disabled="updates.applying" @click="postpone">
          {{ english ? 'Remind me later' : '稍后提醒' }}
        </el-button>
        <el-button type="primary" size="small" :loading="updates.applying" @click="update">
          <i v-if="!updates.applying" class="el-icon-refresh"></i>
          {{ english ? 'Update and refresh' : '更新并刷新' }}
        </el-button>
      </div>
    </aside>
  </div>
</template>

<script>
import { navigationState } from '@/util/navigationFeedback';
import { appUpdateState, applyAppUpdate, postponeAppUpdate } from '@/util/appUpdates';

export default {
  name: 'AppFeedback',
  data() {
    return { navigation: navigationState, updates: appUpdateState };
  },
  computed: {
    english() { return this.$i18n.locale !== 'zh-CN'; }
  },
  methods: {
    update: applyAppUpdate,
    postpone: postponeAppUpdate
  }
};
</script>

<style scoped>
.navigation-progress {
  position: fixed;
  inset: 0 0 auto;
  height: 3px;
  z-index: 10000;
  pointer-events: none;
}
.navigation-progress__bar {
  height: 100%;
  background: var(--el-color-primary);
  transform-origin: left;
  transition: transform 180ms ease-out;
}
.app-update {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 9999;
  width: 420px;
  max-width: calc(100vw - 40px);
  box-sizing: border-box;
  padding: 20px 24px 20px;
  border: 1px solid var(--el-border-color-lighter, #ebeef5);
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
}
.app-update__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}
.app-update__title {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  color: #303133;
}
.app-update__close {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  margin: -2px -4px 0 0;
  padding: 0;
  border: 0;
  background: transparent;
  color: #c0c4cc;
  font-size: 16px;
  line-height: 24px;
  cursor: pointer;
}
.app-update__close:hover:not(:disabled) {
  color: #909399;
}
.app-update__close:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}
.app-update__desc {
  margin: 10px 0 0;
  font-size: 14px;
  line-height: 22px;
  color: #606266;
}
.app-update__error {
  margin: 8px 0 0;
  font-size: 13px;
  line-height: 20px;
  color: var(--el-color-danger);
}
.app-update__actions {
  display: flex;
  justify-content: flex-end;
  flex-wrap: nowrap;
  gap: 8px;
  margin-top: 20px;
}
.app-update__actions .el-button {
  margin: 0;
  white-space: nowrap;
}
.app-update__actions .el-button .el-icon-refresh {
  margin-right: 4px;
}
@media (prefers-reduced-motion: reduce) {
  .navigation-progress__bar { transition: none; }
}
</style>
